import { LOCATION_PRE_PROCESSOR_STATUS} from '../../../misc/commons'
import locationpreprocessorServices from '../../../services/notisphere/locationpreprocessor'
import {FilterConnections_Key, AG_GridCustomizedTableHeaders_Key, Notisphere_LocationPreProcessor_AgGrid} from '../../../misc/tableHeaders'
import { _findObj } from '../../../misc/genericFunctions'
export default {
    props: {

    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            search: {
                status: null,
                category: null,
                supplierName: null,
            },
            status: null,
            locationPreProcessor_status: LOCATION_PRE_PROCESSOR_STATUS,
            supplierOrgId: null,
            listSupplier: [],
            columnDefs: [],
            gridOptions: {
                rowSelection: 'single',
                rowModelType: 'serverSide',
                enableRangeSelection: true,
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                onRowClicked: this.onRowClicked,
                onCellClicked: this.onCellClicked,
                getContextMenuItems: this.getContextMenuItems,
                context: {
                    viewJob: this.viewJob,
                    editJob: this.editJob,
                    deleteJob: this.deleteJob
                }
            },
            rowModelType: 'serverSide',
            defaultColDef: {
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
            },
            rowData: [],
            gridApi: null,
            columnApi: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            frameworkComponents: {},
            SavedAllFilterConnections: this.$store.state.SavedAllFilterConnections.filter(s=>s.user_id==this.$store.state.user.id)[0],
            FilterConnections_Data: JSON.parse( localStorage.getItem(FilterConnections_Key))?.filter(s=>s.user_id==this.$store.state.user.id)[0],
        }
    },
    beforeMount() {
        this.columnDefs = Notisphere_LocationPreProcessor_AgGrid
    },
    mounted() {
        this.findSuppliers()
        if(this.FilterConnections_Data!=null && this.FilterConnections_Data!=undefined)
        {
            if(this.FilterConnections_Data.SavedNotisphereConnections.Page_LocationPreProcessor!=null)
            {
                this.search.status=this.FilterConnections_Data.SavedNotisphereConnections.Page_LocationPreProcessor.status
                this.search.supplierName=this.FilterConnections_Data.SavedNotisphereConnections.Page_LocationPreProcessor.supplierName
            }
        }
    },
    methods: {
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login = this.table_Connection_Data.Notisphere_Login || {}
            this.table_Connection_Data.Notisphere_Login.LocationPreprocessor_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Notisphere_Login?.LocationPreprocessor_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
        },
        onFilterChanged(event) {
            this.table_Connection_Data.Notisphere_Login = this.table_Connection_Data.Notisphere_Login || {}
            this.table_Connection_Data.Notisphere_Login.LocationPreprocessor_Filters = event.api.getFilterModel()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Notisphere_Login?.LocationPreprocessor_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onRowClicked(params) {
            // Check if the click came from the action column by examining the event target
            const event = params.event
            if (event && event.target) {
                // Check if the clicked element or its parents have action-related classes
                const clickedElement = event.target
                const isActionColumn = clickedElement.closest('.actionBtn') ||
                                     clickedElement.closest('.dropdown-menu') ||
                                     clickedElement.classList.contains('actionBtn') ||
                                     clickedElement.classList.contains('dropdown-item')
                // If click came from action column, don't trigger row click
                if (isActionColumn) {
                    return
                }
            }
            this.viewJob(params.data)
        },
        onCellClicked(params) {
            // Handle action button clicks
            const event = params.event
            if (event && event.target) {
                const clickedElement = event.target
                const actionElement = clickedElement.closest('[data-action]')

                if (actionElement) {
                    const action = actionElement.getAttribute('data-action')
                    const item = params.data
                    switch (action) {
                    case 'edit':
                        this.editJob(item, event)
                        break
                    case 'view':
                        this.viewJob(item, event)
                        break
                    case 'deactivate':
                        this.deleteJob(item, event)
                        break
                    }
                }
            }
        },
        applyFilters() {
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        getContextMenuItems(params) {
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.filterModel = that.gridApi.getFilterModel()

            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        search: that.searchQuery.globalSearch,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search,
                        email: email,
                    }
                    const resp = await locationpreprocessorServices.downloadAgGridLocationPreProcessorXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        findSuppliers() {
            locationpreprocessorServices.getLocationPreProcessorSuppliers().then(resp => {
                this.listSupplier = resp.data.d
            })
        },
        addMoreClick() {
            this.$router.push({ name: 'noti_LocationPreProcessor_ItemDetail' })
        },
        addknownProviderClick() {
            this.$router.push({ name: 'noti_Known_Provider' })
        },
        fetchData(params) {
            params?.api?.deselectAll()
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params?.api
            that.columnApi = params?.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    // Handle filters from AG Grid
                    const filterModel = params.request?.filterModel || {}
                    that.search.filterModel = that.gridApi?.getFilterModel()
                    // Save filter connections
                    that.SavedAllFilterConnections.SavedNotisphereConnections.Page_LocationPreProcessor.status = that.search.status
                    that.SavedAllFilterConnections.SavedNotisphereConnections.Page_LocationPreProcessor.supplierName = that.search.supplierName
                    localStorage.setItem(FilterConnections_Key, JSON.stringify(that.$store.state.SavedAllFilterConnections))
                    locationpreprocessorServices.findLocationPreprocessor({
                        ...that.searchQuery,
                        search: that.searchQuery.globalSearch,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        ...that.search
                    }).then(resp => {
                        if (!resp.error) {
                            const recordsarray = resp.data.d.c
                            that.total = resp.data.d.t
                            that.items = recordsarray
                            if(that.total == 0){
                                that.gridApi?.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi?.hideOverlay()
                            }
                            return recordsarray
                        }
                    }).then(response => {
                        params.successCallback(response)
                    })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            // register datasource with the grid
            params?.api?.setServerSideDatasource(datasource)
        },
        viewJob(item) {
            this.$router.push({ name: 'noti_Location_preProcessorView', params: { id: item.preProcessorId } })
        },
        editJob(item, e) {
            this.$router.push({ name: 'noti_LocationPreProcessor_EditItem', params: { id: item.preProcessorId } })
            if (e) {
                e.stopPropagation()
            }
        },
        deleteJob(item, e = null) {
            this._showConfirm('Are you sure you want to deactivate the job, this cannot be undone?', { title: 'Deactivate Job', variant: 'danger' }).then(confirm => {
                if (confirm) {
                    locationpreprocessorServices.deleteLocationPreProcessorJob(item.preProcessorId).then(resp => {
                        if (!resp.error) {
                            this.fetchData()
                            this._showToast('Location Pre-Processor job Deleted!')
                        }
                    })
                }
            })
            if (e) {
                e.stopPropagation()
            }
        },
        onGlobalSearchChange(searchValue) {
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
    }
}